import { useEffect, useState } from "react";
import { CardDetails } from "../../../../common/components/CardDetails/CardDetails";
import style from "./style.module.scss";
import { BagService } from "../../../../common/services/merchandise_request";
import { HttpStatusCode } from "axios";
import { Loader } from "../../../../common/components/Loader/Loader";
import { useParams } from "react-router";

type StorageBagDetailType = {
  initialValue: any;
};

const StorageBagDetail = ({
  initialValue,
}: StorageBagDetailType) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const { id: locationId } = useParams();
  const [data, setData] = useState<any>({});

  const id = initialValue?.["@id"]?.split("/").pop();

  useEffect(() => {
    if (id) {
      getStorageBag(Number(id));
    }
  }, [id]);

  const getStorageBag = async (id: number) => {
    try {
      setIsLoading(true);

      const res = await BagService.getBagById(id);

      if (res?.status === HttpStatusCode.Ok) {
        setData(res?.data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const renderValue = (value: any) => {
    return value !== null &&
      value !== undefined &&
      value !== ""
      ? value
      : "-";
  };

  const renderBoolean = (value: boolean | undefined) => {
    if (value === null || value === undefined) {
      return "-";
    }

    return value ? "Oui" : "Non";
  };

  const matchingStorage = data?.storageLoadData?.find(
    (item: any) => {
      const storageId = item.storage?.["@id"]?.split("/").pop();

      return storageId == locationId;
    }
  );

  return (
    <div>
      <Loader isLoading={isLoading} />

      <CardDetails className="d-flex gap-2 flex-column">
        <div className={style.details__item}>
          <span className={style.details__subtitle}>
            Désignation :
          </span>

          <span className={style.details__value}>
            {renderValue(data?.designation)}
          </span>
        </div>

        <div className={style.details__item}>
          <span className={style.details__subtitle}>
            N° de Lot :
          </span>

          <span className={style.details__value}>
            {renderValue(data?.batchNumber)}
          </span>
        </div>

        <div className={style.details__item}>
          <span className={style.details__subtitle}>
            Marque :
          </span>

          <span className={style.details__value}>
            {renderValue(data?.brand)}
          </span>
        </div>

        <div className={style.details__item}>
          <span className={style.details__subtitle}>
            Contenu :
          </span>

          <span className={style.details__value}>
            {renderValue(data?.content)}
          </span>
        </div>

        <div className={style.details__item}>
          <span className={style.details__subtitle}>
            Conditionnement :
          </span>

          <span className={style.details__value}>
            {renderValue(data?.packaging)}
          </span>
        </div>

        <div className={style.details__item}>
          <span className={style.details__subtitle}>
            Type de chargement :
          </span>

          <span className={style.details__value}>
            {renderValue(data?.loadType?.name)}
          </span>
        </div>

        <div className={style.details__item}>
          <span className={style.details__subtitle}>
            État :
          </span>

          <span className={style.details__value}>
            {renderValue(data?.loadState?.name)}
          </span>
        </div>

        <div className={style.details__item}>
          <span className={style.details__subtitle}>
            Poids Net (T) :
          </span>

          <span className={style.details__value}>
            {renderValue(data?.netWeight)}
          </span>
        </div>

        <div className={style.details__item}>
          <span className={style.details__subtitle}>
            Tonnage en stock (T) :
          </span>

          <span className={style.details__value}>
            {renderValue(matchingStorage?.tonnageInStock)}
          </span>
        </div>

        <div className={style.details__item}>
          <span className={style.details__subtitle}>
            Quantité :
          </span>

          <span className={style.details__value}>
            {renderValue(data?.qty)}
          </span>
        </div>

        <div className={style.details__item}>
          <span className={style.details__subtitle}>
            Stock valide :
          </span>

          <span className={style.details__value}>
            {renderValue(data?.validStorageTxt)}
          </span>
        </div>

        <div className={style.details__item}>
          <span className={style.details__subtitle}>
            Stock défectueux :
          </span>

          <span className={style.details__value}>
            {renderValue(data?.defectiveStorageTxt)}
          </span>
        </div>

        <div className={style.details__item}>
          <span className={style.details__subtitle}>
            Stock total :
          </span>

          <span className={style.details__value}>
            {renderValue(data?.totalStorageTxt)}
          </span>
        </div>

        <div className={style.details__item}>
          <span className={style.details__subtitle}>
            Reliquat en stock :
          </span>

          <span className={style.details__value}>
            {renderValue(data?.remainingStorageTxt)}
          </span>
        </div>

        <div className={style.details__item}>
          <span className={style.details__subtitle}>
            Excédent :
          </span>

          <span className={style.details__value}>
            {renderValue(data?.overageTxt)}
          </span>
        </div>

        <div className={style.details__item}>
          <span className={style.details__subtitle}>
            Emplacement :
          </span>

          <span className={style.details__value}>
            {renderValue(matchingStorage?.storage?.name)}
          </span>
        </div>

        <div className={style.details__item}>
          <span className={style.details__subtitle}>
            Lieu de retour prévu :
          </span>

          <span className={style.details__value}>
            {renderValue(data?.expectedReturnLocation?.name)}
          </span>
        </div>

        <div className={style.details__item}>
          <span className={style.details__subtitle}>
            Importé :
          </span>

          <span className={style.details__value}>
            {renderBoolean(data?.imported)}
          </span>
        </div>

        <div className={style.details__item}>
          <span className={style.details__subtitle}>
            Contrôlé :
          </span>

          <span className={style.details__value}>
            {renderBoolean(data?.controlled)}
          </span>
        </div>

        <div className={style.details__item}>
          <span className={style.details__subtitle}>
            Mouvement :
          </span>

          <span className={style.details__value}>
            {renderValue(data?.movementTypeTxt)}
          </span>
        </div>
      </CardDetails>
    </div>
  );
};

export default StorageBagDetail;